//*****************************************************************************************************************
//*****************************************************************************************************************
//*************************************(IF YOU HAVE REACHED HERE)**************************************************
//********************************(PLEASE UNDERSTAND THIS PROJECT IS)**********************************************
//****************************************(MADE AND MANAGED BY)****************************************************
//******************************************(KUSHAL VERMA)*********************************************************
//******************************(DON'T TRY TO COPY OR STEAL THIS PROJECT)******************************************
//***********(DO APPRECIATE THE TIME AND EFFORTS THAT I HAVE SPENT IN MAKING THIS PROJECT ALL BY MYSELF)***********
//***************************************(GITHUB: vkushal28)*******************************************************
//****************************(FEEL FREE TO REACH ME OUT FOR ANY QUERIES)******************************************
//**************************(for personal mails : vermakushal.28@gmail.com)****************************************
//*************************(for work related mails : kush.expclick@gmail.com)**************************************
//*****************************************************************************************************************
//*****************************************************************************************************************

//*******************Demo pattern of objects****************
// {
//   img:
//     "https://drive.google.com/uc?export=view&id=",
//   frame: "",
//   location: "",
// },

export const architectureURLs = [
  {
    img:
      "https://drive.google.com/uc?export=view&id=11x15AOFrsTtEV1J5CciXhraam4uw8Gyf",
    frame: "Worli sea-link Bandra, Mumbai, Maharashtra, India",
    location: "Mumbai, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=14X0ydosJVtlfGJ0vULkWo6pX_5S4RjL8",
    frame: "Taj Hotel",
    location: "Mumbai, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=14K7kLHFQz5M4nIcv4c9Tpc39GQbC8sAu",
    frame: "Gateway of India",
    location: "Mumbai, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=14WPxkUrBfTr3dx-DdUfAKWRwrhVdEP-_",
    frame: "Old historic gate",
    location: "Alka talkies chowk, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=14Md6iAvVj1hu4fuyKQiertONPNmLg-Z8",
    frame: "Mandai street",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=14j5yyU5BLUB0-L-2iSxGrsqMOv4lA5A0",
    frame: "Mandai",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=14M_3kIXVYwO1I5kJNYdw_VCfSguD9GM0",
    frame: "Tourist houses",
    location: "Lavasa, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=14PolS4pTWMYnEPRYSUJEqxT62rhd_hT4",
    frame: "TinselTown by Kohinoor",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=14TaApiYk4_uwp2FyBnePu91Nm6nu-h49",
    frame: "Infosys gate 1",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=14TOxgLcEU3Mk8fz_Qe4jLS--lW_56xq0",
    frame: "Infosys gate 1",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=125SWFetKr7HKokQgGN8rkvfdlbFYYugC",
    frame: "Employement Care centers",
    location: "Infosys Ltd., Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=11zXt-0nYw5LXWwh8Jnn-Ey5Vm4ltwBjy",
    frame: "Multiplex",
    location: "Infosys Ltd., Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=127ZkfjgmshmNpOxRoScZOgYuakQO7hHQ",
    frame: "Global Education center",
    location: "Infosys Ltd., Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=126ZPlR39Hr4Z4Ocxt8V3SRa9R7fsLerQ",
    frame: "Global Education center",
    location: "Infosys Ltd., Mysore, Karnataka, India",
  },
];
